module.exports = __webpack_public_path__ + "img/field-dark-3.501d1a11.svg";